module.exports = __webpack_public_path__ + "img/TITLE-03.91497d26.png";